import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiMenu, FiX } = FiIcons;

const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <nav className={`fixed w-full z-50 transition-all duration-300 ${isScrolled ? 'bg-neutral-surface/90 backdrop-blur-md shadow-sm py-3' : 'bg-transparent py-5'}`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center">

          {/* Logo */}
          <div className="flex items-center gap-2.5 cursor-pointer">
            <div className="w-10 h-10 bg-primary rounded-xl flex items-center justify-center shadow-soft flex-shrink-0">
              <svg viewBox="0 0 40 40" className="w-6 h-6" fill="none">
                <circle cx="20" cy="20" r="12" stroke="white" strokeWidth="2.5" />
                <path d="M14 20 Q20 14 26 20 Q20 26 14 20Z" fill="white" opacity="0.9" />
                <line x1="20" y1="8" x2="20" y2="4" stroke="white" strokeWidth="2.5" strokeLinecap="round" />
              </svg>
            </div>
            <span className="text-base font-bold text-text-primary tracking-tight leading-tight">
              Pickleball<br />
              <span className="text-primary">Insight Coach</span>
            </span>
          </div>

          {/* Desktop Nav */}
          <div className="hidden md:flex items-center gap-8">
            <a href="#features" className="text-text-secondary hover:text-primary transition-colors font-medium">Features</a>
            <a href="#how-it-works" className="text-text-secondary hover:text-primary transition-colors font-medium">How it Works</a>
            <a href="#testimonials" className="text-text-secondary hover:text-primary transition-colors font-medium">Reviews</a>
            <a href="#download" className="bg-primary hover:bg-primary-dark text-white px-6 py-2.5 rounded-full font-medium transition-all shadow-md hover:shadow-lg transform hover:-translate-y-0.5">
              Download Free
            </a>
          </div>

          {/* Mobile Menu Toggle */}
          <button
            className="md:hidden text-text-primary p-2"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          >
            <SafeIcon icon={mobileMenuOpen ? FiX : FiMenu} className="text-2xl" />
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      <AnimatePresence>
        {mobileMenuOpen && (
          <motion.div
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: 'auto' }}
            exit={{ opacity: 0, height: 0 }}
            className="md:hidden bg-neutral-surface border-b border-neutral-border overflow-hidden"
          >
            <div className="px-4 pt-2 pb-6 space-y-4 flex flex-col">
              <a href="#features" onClick={() => setMobileMenuOpen(false)} className="block px-3 py-2 text-text-secondary hover:text-primary hover:bg-neutral-bg rounded-lg font-medium">Features</a>
              <a href="#how-it-works" onClick={() => setMobileMenuOpen(false)} className="block px-3 py-2 text-text-secondary hover:text-primary hover:bg-neutral-bg rounded-lg font-medium">How it Works</a>
              <a href="#download" onClick={() => setMobileMenuOpen(false)} className="bg-primary text-white text-center px-4 py-3 rounded-xl font-medium mt-4 shadow-md">
                Download Free
              </a>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </nav>
  );
};

export default Navbar;